import {
  ELanguage,
} from '../type/locale.ts';

export function getPrimevueCalendarFormat(locale: ELanguage) {
  let format: string = 'dd.mm.yy';

  let exhaustiveCheck: never;
  switch (locale) {
    case ELanguage.EN_GB:
      format = 'dd/mm/yy';
      break;
    case ELanguage.DE:
    case ELanguage.PL:
    case ELanguage.SK:
      format = 'dd.mm.yy';
      break;
    case ELanguage.EN_US:
      format = 'mm/dd/yy';
      break;
    default:
      exhaustiveCheck = locale;
      throw new Error(`Missing locale: ${exhaustiveCheck}.`);
  }

  return format;
}
